import React from 'react';
import Form from '../login-form';
import type { IProps } from './types';
import TestimonialsCarousel from '../../../../shared/components/testimonials-carousel';
import { SHLogoDark } from '../../../../shared/svg';
import { SHLogoTypography } from '../../../../shared/svg/sh-typography';
import { getIsRequestPending } from '../../../../shared/utils';
import { isInternalUrl } from '../../../../shared/utils/is-internal-url';

const Signup: React.FC<IProps> = ({
  agencyConfig,
  agencyConfigRequestStatus,
}) => {
  const isWhitelabel = !!agencyConfig?.clientBaseUrl;

  return (
    <>
      {(getIsRequestPending(agencyConfigRequestStatus) && !isInternalUrl()) ||
      isWhitelabel ? null : (
        <div className="testimonials-container">
          <div className="d-flex align-items-center">
            <SHLogoDark />
            <div className="bs-ml-10">
              <SHLogoTypography />
            </div>
          </div>

          <TestimonialsCarousel />
          <p className="copyright">
            &copy;{`${new Date().getFullYear()} Saleshandy`}
          </p>
        </div>
      )}
      <Form />
    </>
  );
};

export default Signup;
